<template>
  <div class="email-validate">
    <div v-if="validating">{{ $t("validationPage.validating") }}</div>
    <div v-else>
      <div v-if="success" class="div-success">
        <p>{{ $t("validationPage.validationSuccess") }}</p>
        <p>
          <strong
            >{{ $t("validationPage.protocol") }}: {{ data.protocol }}</strong
          >
        </p>
      </div>
      <div v-if="error" class="div-error">
        {{ $t("validationPage.protocolError") }}
      </div>
    </div>
    <BeFooter style="margin-top: 1rem" background="#ffffff" />
  </div>
</template>

<script>
import axios from "axios";
import BeFooter from "./BeFooter.vue";

export default {
  components: { BeFooter },
  name: "FormPage",
  props: {
    msg: String,
    site_url: process.env.VUE_APP_SITE_URL,
  },

  data() {
    return {
      validating: true,
      success: false,
      error: false,
      data: {},
    };
  },

  created() {
    const { query } = this.$route;
    const { language = "pt-BR" } = query;
    this.$i18n.locale = language;

    this.validateEmail();
  },

  methods: {
    validateEmail() {
      this.validating = true;
      let url = process.env.VUE_APP_API_URL;
      url += "lgpd-titular/email-success";
      url += `/${this.$route.params.client}/${this.$route.params.holder_uuid}`;
      axios
        .get(url)
        .then((res) => {
          this.success = true;
          this.data = res.data;
          if (this.data.url) {
            let query = "?";
            if (this.data.url.indexOf("?") > -1) {
              query = "&";
            }
            window.location =
              this.data.url +
              query +
              "bctitular=sucesso&bcprotocolo=" +
              this.data.protocol;
          }
        })
        .catch((err) => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.validating = false;
        });
    },

    getLogo() {
      return process.env.VUE_APP_LOGO;
    },
  },
};
</script>

<style scoped>
.email-validate {
  padding: 20px;
  max-width: 800px;
  margin: auto;
}
.email-validate img {
  max-height: 40px;
}

.div-error,
.div-success,
.div-info {
  background-color: #27ae60;
  color: #fff;
  padding: 20px;
  border-radius: 5px;
}

.div-error {
  background-color: #e74c3c;
}

.div-info {
  margin-top: 20px;
  text-align: center;
}
</style>
